import axios from 'axios';
import { API_URL_V2 } from '../../constants/api';

const employer = `${API_URL_V2}/get/employer/surveys`;
const employerPost = `${API_URL_V2}/post/employer/surveys`;
const publicGet = `${API_URL_V2}/get/surveys`;
const publicPost = `${API_URL_V2}/post/surveys`;

const unwrap = ({ data }) => {
	if (data.status !== 'success') {
		throw new Error(data.message || 'Something went wrong.');
	}
	return data.data;
};

export const errorMessage = (error) =>
	error.response?.data?.message || error.message || 'Something went wrong.';

export const availability = async () =>
	unwrap(await axios.get(`${employer}/availability`, { withCredentials: true }));
export const listSurveys = async (params = {}) =>
	unwrap(await axios.get(employer, { withCredentials: true, params }));
export const getInsights = async (days = 90, filters = {}) =>
	unwrap(
		await axios.get(`${employer}/insights`, {
			withCredentials: true,
			params: { days, ...filters },
		})
	);
export const createSurvey = async (payload) =>
	unwrap(await axios.post(employerPost, payload, { withCredentials: true }));
export const getSurvey = async (id) =>
	unwrap(await axios.get(`${employer}/${encodeURIComponent(id)}`, { withCredentials: true }));
export const cancelSurvey = async (id) =>
	unwrap(
		await axios.post(
			`${employerPost}/${encodeURIComponent(id)}/cancel`,
			{},
			{ withCredentials: true }
		)
	);
export const remindSurvey = async (id) =>
	unwrap(
		await axios.post(
			`${employerPost}/${encodeURIComponent(id)}/remind`,
			{},
			{ withCredentials: true }
		)
	);

export const retrySurveyEmail = async (id) =>
	unwrap(
		await axios.post(
			`${employerPost}/${encodeURIComponent(id)}/retry-email`,
			{},
			{ withCredentials: true }
		)
	);

export const getPublicSurvey = async (token) =>
	unwrap(await axios.get(`${publicGet}/${encodeURIComponent(token)}`));
export const savePublicAnswer = async (token, questionKey, value) =>
	unwrap(
		await axios.post(`${publicPost}/${encodeURIComponent(token)}/answers`, {
			question_key: questionKey,
			value,
		})
	);
export const submitPublicSurvey = async (token) =>
	unwrap(await axios.post(`${publicPost}/${encodeURIComponent(token)}/submit`, {}));
export const declinePublicSurvey = async (token) =>
	unwrap(await axios.post(`${publicPost}/${encodeURIComponent(token)}/decline`, {}));

export const listTemplates = async () =>
	unwrap(await axios.get(`${employer}/templates`, { withCredentials: true }));
export const listStarters = async () =>
	unwrap(await axios.get(`${employer}/templates/starters`, { withCredentials: true }));
export const getTemplate = async (id) =>
	unwrap(
		await axios.get(`${employer}/templates/${encodeURIComponent(id)}`, {
			withCredentials: true,
		})
	);
export const createTemplate = async (definition) =>
	unwrap(await axios.post(`${employerPost}/templates`, definition, { withCredentials: true }));
export const changeTemplate = async (id, action, payload) =>
	unwrap(
		await axios.post(`${employerPost}/templates/${encodeURIComponent(id)}/${action}`, payload, {
			withCredentials: true,
		})
	);

export const uploadImport = async (file, versionId, key, dateFormat = 'Y-m-d') => {
	const form = new FormData();
	form.append('file', file);
	form.append('template_version_id', String(versionId));
	form.append('idempotency_key', key);
	form.append('date_format', dateFormat);
	return unwrap(await axios.post(`${employerPost}/imports`, form, { withCredentials: true }));
};
export const listImports = async (page = 0) =>
	unwrap(await axios.get(`${employer}/imports`, { withCredentials: true, params: { page } }));
export const getImport = async (id, page = 0) =>
	unwrap(
		await axios.get(`${employer}/imports/${encodeURIComponent(id)}`, {
			withCredentials: true,
			params: { page },
		})
	);
export const confirmImport = async (id) =>
	unwrap(
		await axios.post(
			`${employerPost}/imports/${encodeURIComponent(id)}/confirm`,
			{},
			{ withCredentials: true }
		)
	);
export const cancelImport = async (id) =>
	unwrap(
		await axios.post(
			`${employerPost}/imports/${encodeURIComponent(id)}/cancel`,
			{},
			{ withCredentials: true }
		)
	);
export const importErrors = async (id) =>
	unwrap(
		await axios.get(`${employer}/imports/${encodeURIComponent(id)}/errors`, {
			withCredentials: true,
		})
	);
